export default "__VITE_ASSET__BkBHG$oV__"